import '../assets/NcMentionBubble.css';
import { generateUrl } from "@nextcloud/router";
import { checkIfDarkTheme } from "../functions/isDarkTheme/index.mjs";
function getAvatarUrl(user, options) {
  const size = (options?.size || 64) <= 64 ? 64 : 512;
  const guestUrl = options?.isGuest ? "/guest" : "";
  const themeUrl = options?.isDarkTheme ?? checkIfDarkTheme(document.body) ? "/dark" : "";
  return generateUrl(`/avatar${guestUrl}/{user}/{size}${themeUrl}?guestFallback=true`, {
    user,
    size
  });
}
export {
  getAvatarUrl as g
};
//# sourceMappingURL=NcMentionBubble.vue_vue_type_style_index_0_scoped_3c4a673d_lang.mjs.map
